import { mapState, mapActions, mapMutations } from 'vuex'
import Scrollbar from '@/components/scrollbar/scrollbar.vue'
import PageDropdown from "@/components/page-dropdown/page-dropdown.vue"
import CreateEncashmentModal from '@/components/modals/create-encashment-modal/create-encashment-modal.vue'
import ConfirmEncashmentModal from '@/components/modals/confirm-encashment-modal/confirm-encashment-modal.vue'
import IcEdit from '@/assets/svg/ic-edit.svg?inline'
import IcPlus from '@/assets/svg/ic-plus.svg?inline'

export default {
  name: 'Encashments',
  props: {
    adminShiftId: {
      type: Number | String,
      required: true
    },
    encashments: {
      /**
       * {
       *   encashments_list: Array<{ encashment_id, amount, datetime_created }>
       *   encashments_sum: number
       *   amount_for_encashment: number
       * }
       */
      type: Object,
      required: true
    }
  },
  components: {
    PageDropdown,
    Scrollbar,
    CreateEncashmentModal,
    ConfirmEncashmentModal,
    IcEdit,
    IcPlus
  },
  data() {
    return {
      editEncashment: null,
      isWasCancelEncashment: false
    }
  },
  computed: {
    showAmountForEncashment() {
      if (this.finalEncashmentData) {
        return this.finalEncashmentData.amount_for_encashment
      }
      if (this.editEncashment) {
        return this.editEncashment.amount
      }
      return 0
    },
    ...mapState({
      finalEncashmentData: state => state.encashment.finalEncashmentData,
      finalEncashment: state => state.encashment.finalEncashment
    })
  },
  methods: {
    ...mapMutations({
      setFinalEncashmentData: 'encashment/SET_FINAL_ENCASHMENT_DATA',
      setFinalEncashment: 'encashment/SET_FINAL_ENCASHMENT'
    }),
    ...mapActions({
      createFinalEncashment: 'encashment/createFinalEncashment',
      cancelLastEncashment: 'encashment/cancelLastEncashment',
      updateEncashment: 'encashment/updateEncashment'
    }),

    prepareFinalEncashment() {
      this.setFinalEncashmentData({
        admin_shift_id: this.adminShiftId,
        amount_for_encashment: this.encashments.amount_for_encashment
      })
      this.$nextTick(() => {
        this.$refs['create-encashment-modal'].show()
      })
    },

    onEeditEncashment(encashment) {
      this.editEncashment = encashment
      this.$nextTick(() => {
        this.$refs['create-encashment-modal'].show()
      })
    },
    
    
    async onCreateEncashment({ amount }) {
      if (this.finalEncashmentData) {
        await this.createFinalEncashment(amount)
        this.$nextTick(() => {
          this.$refs['confirm-encashment-modal'].show()
        })
      } else if (this.editEncashment) {
        await this.updateEncashment({
            encashment_id: this.editEncashment.encashment_id,
            amount
        })
        this.editEncashment = null
        this.$refs['create-encashment-modal'].hide()
      }
    },
    onEncashmentModalHide() {
      if (this.finalEncashmentData) {
        this.setFinalEncashmentData(null)
        if (this.finalEncashment) {
          this.setFinalEncashment(null)
          this.$emit('change-encashment')
        }
      } else {
        if (!this.editEncashment) {
          this.$emit('change-encashment')
        } else {
          this.editEncashment = null
        }
      }
      
    },
    /**
     * здесь не через async await,
     * так как логика удаления finalEncashment
     * будет нарушена. Поскольку onCancelEncashment
     * и onConfirmEncashmentHide должны выполнятся синхронно
     * в той последовательности как идут события cancel-encashment
     * и hide модалки confirm-encashment-modal
     */
     onCancelEncashment() {
      if (this.finalEncashmentData) {
        this.isWasCancelEncashment = true
        this.cancelLastEncashment(this.finalEncashment.encashment_id)
        .then(() => {
          this.setFinalEncashment(null)
        })
        .catch(() => {
          this.isWasCancelEncashment = false
          this.$refs['confirm-encashment-modal'].show()
        })
      }
    },
    onConfirmEncashmentHide() {
      if (!this.isWasCancelEncashment) {
        this.$refs['create-encashment-modal'].hide()
      } else {
        this.isWasCancelEncashment = false
      }
    }
  }
}